var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mx-2",attrs:{"loading":_vm.loading,"fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.loadMenages()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-cached ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }